import React from 'react';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import * as firebase from 'firebase';
import { createMuiTheme, responsiveFontSizes, ThemeProvider } from '@material-ui/core/styles';
import '../view/css/NavBar.css';
import '../view/css/ContactUsModal.css';
import {ContactUsModal2View} from '../view/ContactUsModal2View';
import { sendMessage2 } from '../model/contact_model/sendMessage2';

const theme = createMuiTheme({
    typography: {
        fontFamily: 'Rubik',
        fontSize: 18,
    },
});


export function ContactUsModal2() {
    const [open, setOpen] = React.useState(false);
    const [error, setError] = React.useState(false);
    const [name, setName] = React.useState("");
    const [message, setMessage] = React.useState("");
    const [email, setEmail] = React.useState("");
    const [sucess,setSuccess] = React.useState(false);
    const [notify,setNotify] = React.useState("");
    var firestore = firebase.firestore();
    const db = firestore.collection("UserFeedback");

    const handleClickOpen = () => {
        setOpen(true);
    };
    const handleSuccesclose = () =>{
        setOpen(false);
    }
    const handleClose = () => {
        setOpen(false);
        setError(false);
        setEmail("");
        setName("");
        setMessage("");
    };

    const submit = (e) => {

        e.preventDefault();
        setNotify(message);
        sendMessage2(db, name, email, message);
        
        setSuccess(true);
    
    }

    const inputName = (e) => {
        setName(e.target.value)
    }
    const inputEmail = (e) => {
        setEmail(e.target.value)
    }

    const inputMessage = (e) => {
        setMessage(e.target.value)
    }

    return (
       <ContactUsModal2View handleClickOpen={handleClickOpen} theme={theme} sucess={sucess} open={open} handleSuccesclose={handleSuccesclose} message={message} handleClose={handleClose} error={error} inputName={inputName} name={name} inputEmail={inputEmail} email={email} inputMessage={inputMessage} submit={submit}  />
    );
}


